import { useHookstate } from "@hookstate/core";
import { meetupsTabs } from "../../../misc/constants";
import { updateLocalStateRaw } from "../../../misc/utils";
import Meetups from "./Meetups";
import { Categories } from "../../../components/Categories";
import { HasRole } from "../../../components/HasRole";
import MeetupsAdmin from "../../../components/Meetups/MeetupsAdmin/MeetupsAdmin";

export const MeetupsPage = () => {
    const localState = useHookstate({});
    const state: Record<string, any> = localState.get();
    const currentTab = state.currentTab || "list";

    const updateTab = (key: string) => () => {
        updateLocalStateRaw(localState, 'currentTab')(key)
    }

    return (
        <div className="flex flex-col gap-4 bg-[#F0F3FA80] w-full h-full p-3 sm:p-4 md:p-6 lg:p-8 overflow-hidden">
            <div className="flex flex-row self-start bg-white rounded-xl p-1.5 sm:p-2 gap-1.5 sm:gap-2 md:gap-3 overflow-x-auto overflow-y-hidden flex-shrink-0 items-center min-h-fit shadow-sm">
                {meetupsTabs.map(t => {
                    const isActive = currentTab === t.key;
                    const Icon = t.icon;
                    return (
                        <HasRole roles={t.roles}>
                            <div 
                                key={t.key} 
                                className={`flex flex-row transition-all duration-200 ${isActive ? 'bg-valley-main shadow-sm' : 'hover:bg-gray-50'} gap-[6px] px-2 sm:px-3 py-1.5 sm:py-2 items-center rounded-lg cursor-pointer whitespace-nowrap flex-shrink-0`} 
                                onClick={updateTab(t.key)}
                            >
                                <Icon additionalStyle={isActive ? 'text-white' : 'text-valley-main'} />
                                <span className={`font-medium leading-[19.2px] text-xs sm:text-sm md:text-base ${isActive ? 'text-white' : 'text-valley-black'}`}>
                                    {t.label}
                                </span>
                            </div>
                        </HasRole>
                    )
                })}
            </div>
            <div className="flex-1 min-h-0 overflow-hidden">
                {currentTab === "list" && <Meetups display="list" />}
                {currentTab === "list-decide" && <MeetupsAdmin display="decide" />}
                {currentTab === "categories" && <Categories model="ActivityCategory" />}
            </div>
        </div>
    )
}